import Image from 'next/image';

type Props = {
  mainPhotoURL?: string;
  vimeoId?: string;
  companyName?: string;
};

export const MainImagePc: React.FC<Props> = ({
  mainPhotoURL,
  companyName,
  vimeoId,
}) => {
  const imgWidth = 880;
  const imgHeight = 495;
  return (
    <div className="hidden pc:block">
      {mainPhotoURL &&
        (vimeoId ? (
          <iframe
            src={`https://player.vimeo.com/video/${vimeoId}`}
            className="w-[100%] pc:w-[880px] pc:h-[495px] mt-16 rounded-16"
          />
        ) : (
          <div className="sm:px-0 mt-16">
            <Image
              src={mainPhotoURL}
              alt={`${companyName}のヘッダー`}
              className="w-full rounded-16"
              width={imgWidth}
              height={imgHeight}
            />
          </div>
        ))}
    </div>
  );
};
